import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";





export const HandelRoleTransfer = createAsyncThunk(
  "TransferRoleReducer/HandelRoleTransfer",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferRole/HandelRoleTransfer",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TransferRoleReducer = createSlice({
  name: "TransferRoleReducer",
  initialState: {
   
    TransferRole: {},
    loadingTransferRole: false,
    errorDTransferRole: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(HandelRoleTransfer.pending, (state, action) => {
        state.loadingTransferRole = true;
        state.TransferRole = action.payload;
        state.errorDTransferRole = null;
      })
      .addCase(HandelRoleTransfer.fulfilled, (state, action) => {
        state.loadingTransferRole = false;
        state.TransferRole = action.payload; // Assuming payload has the desired data
      })
      .addCase(HandelRoleTransfer.rejected, (state, action) => {
        state.loadingTransferRole = false;
        state.errorDTransferRole = action.payload;
      })


  },
});

export default TransferRoleReducer.reducer;
